<template>
  <div style="padding: 10px;">
    <el-table v-if="userData && userData.length > 0"
              :data="userData" :summary-method="getSummaries" show-summary stripe height="320"
              style="width: 100%">
      <el-table-column label="课程名称">
        <template slot-scope="props">
          <a style="text-decoration: underline; cursor: pointer;" @click="$projCommon.navTo({path: '/courseDetail/' + props.row.courseId}, {})">{{props.row.courseName}}</a>
        </template>
      </el-table-column>
      <el-table-column label="学习状态">
        <template slot-scope="props">
          <span v-if="props.row.learnStatus == '0'" style="color: grey;">未学习</span>
          <span v-if="props.row.learnStatus == '1'" style="color: #0e932e;">学习中</span>
          <span v-if="props.row.learnStatus == '2'" style="color: #ff3633;">已完成</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格"></el-table-column>
      <el-table-column prop="learnHour" label="学时"></el-table-column>
    </el-table>
    <h5 class="none_ts" v-if="userData.length == '0'">
      <img src="@/assets/images/none_data.jpg" alt="">
      <h4>暂无记录</h4>
    </h5>
  </div>
</template>
<script>
  import clonedeep from 'lodash.clonedeep'
  import utils from '@/utils'
  export default {
    data () {
      return {
        userData: []
      }
    },
    created () {
      if (this.params.inputs.data) {
        this.userData = clonedeep(this.params.inputs.data)
      }
    },
    methods: {
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        if (columns && columns.length > 0) {
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = '合计';
              return;
            }
            if (index === 1) {
              sums[index] = '';
              return;
            }
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return utils.floatAdd(prev, curr)
                } else {
                  return prev;
                }
              }, 0);
              if (column.property == 'price') {
                sums[index] += ' 元';
              } else if (column.property == 'learnHour') {
                sums[index] += ' 学时'
              }
            } else {
              sums[index] = 'N/A';
            }
          });
        }
        return sums;
      }
    },
    props: ['params']
  }
</script>



// WEBPACK FOOTER //
// src/pages/front/courseRecordBox.vue